import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    TabContent, TabPane, Nav, NavItem, NavLink,
    Button,
    Alert,
    UncontrolledAlert
} from "reactstrap"
import apiResponse from '../../../../../services/apiResponse';
import DetailBloc from '../Blocs/DetailBloc'
import DataTable from "react-data-table-component";

const columns = [
    {
      name: 'No',
      cell: (row, index) => (index+1),
      grow: 0,
    },
    {
       name: 'Jabatan',
       selector: 'position_name_tab',
       sortable: true,
    },
    {
       name: 'Persentase Kesesuaian',
       selector: 'calc_position_jpm',
       sortable: true,
    },
    ];

class KesesuaianPenempatan extends Component {

  detailBloc = new DetailBloc()

    constructor(props) {
      super(props)
      this.state = {
        assessment_matrix : this.props.matrixid,
        assessmentuuid : this.props.uuid,
        echeloncode : this.props.echeloncode,
        assDdevGuide : [{}],
        suitableposs : [{}]
      }
    }
    loadDevGuide = async () => {
      const query = {
          uuid: this.state.assessmentuuid
      }
      // console.log(query)
      await this.detailBloc.fetchDevGuide(query)
    }
    loadSuitablePossition = async () => {
      const query = {
          uuid: this.state.assessmentuuid,
          echeloncode : this.state.echeloncode
      }
      // console.log(query)
      await this.detailBloc.fetchSuitablePossision(query)
    }
    componentDidMount() {
        console.log('eselon kode = '+this.state.echeloncode)
        // console.log(this.state.assessmentuuid)
      this.loadDevGuide()
      this.detailBloc.devGuideChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      // console.log('saran')
                      // console.log(response)
                      this.setState({
                          assDdevGuide : response
                      })
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
      })
      this.loadSuitablePossition()
      this.detailBloc.SuitablePossitionChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                    //   console.log('kesesuaian')
                    //   console.log(response)
                      this.setState({
                          suitableposs : response
                      })
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
      })
      
  }
    render() {
      return (
        <Fragment>
          <br />
            {
                (Array.isArray(this.state.suitableposs) && this.state.suitableposs.length)?
                <div style={{border:'solid #f6f6f6'}}>
                    <DataTable title="" columns={columns} data={this.state.suitableposs} pagination/>
                </div>
                : <Shimmer><div style={{width: 500, height: 30}}></div></Shimmer>
            }
                    
        </Fragment>
      )
    }
  }
  export default KesesuaianPenempatan